import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import * as i1 from '@upr-web-primer/dal';
import { DalModule } from '@upr-web-primer/dal';
import { HttpHeaders } from '@angular/common/http';
import * as i2 from '@upr-web-primer/storage';
import { get, sortBy, map } from 'lodash-es';

class MsUtilsModule {
}
MsUtilsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MsUtilsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MsUtilsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MsUtilsModule, imports: [DalModule] });
MsUtilsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MsUtilsModule, imports: [[DalModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MsUtilsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DalModule]
                }]
        }] });

class UtilsService {
    constructor(dalService, localStorage, relativeUrls, defaultValues) {
        this.dalService = dalService;
        this.localStorage = localStorage;
        this.relativeUrls = relativeUrls;
        this.defaultValues = defaultValues;
    }
    loadCountryList() {
        return this.dalService
            .httpRequest(this.relativeUrls.COUNTRY, 'GET', null, this.getHeaders())
            .then((countriesData) => {
            const countries = get(countriesData, 'result') || countriesData;
            if (!countries) {
                return;
            }
            const countryList = sortBy(countries, ['displayName']) || sortBy(countries, ['name']);
            return map(countryList, (value) => {
                return {
                    name: value.displayName || value.name,
                    id: value.code
                };
            });
        })
            .catch(error => {
            throw error;
        });
    }
    loadUsStateList() {
        return this.dalService
            .httpRequest(this.relativeUrls.STATE, 'GET', null, this.getHeaders())
            .then(response => {
            const provStates = get(response, 'result') ||
                get(response, 'result.provStates') ||
                response;
            const stateList = sortBy(provStates, ['displayName']) || sortBy(provStates, ['name']);
            return map(stateList, state => {
                return {
                    name: state.displayName || state.name,
                    id: state.code
                };
            });
        })
            .catch(error => {
            throw error;
        });
    }
    loadPrefixes() {
        return this.dalService.httpRequest(this.relativeUrls.PREFIX, 'GET', null, this.getHeaders(), 0, true);
    }
    validateEmail(emailId, timeout) {
        const request = {
            marketingId: this.defaultValues.SOURCE_MARKETING_ID,
            email: emailId
        };
        const url = this.relativeUrls.VALIDATE_EMAIL;
        return this.dalService.httpRequest(url, 'POST', request, this.getHeaders(), timeout);
    }
    getHeaders() {
        let httpHeaders = new HttpHeaders();
        const instanceId = this.localStorage.getItem('InteractGuestId');
        if (instanceId) {
            httpHeaders = httpHeaders.set('x-instance-id', instanceId);
        }
        return httpHeaders;
    }
}
UtilsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UtilsService, deps: [{ token: i1.DalService }, { token: i2.LocalStorageService }, { token: 'RelativeUrls' }, { token: 'DefaultValues' }], target: i0.ɵɵFactoryTarget.Injectable });
UtilsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UtilsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UtilsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.DalService }, { type: i2.LocalStorageService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['RelativeUrls']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['DefaultValues']
                }] }]; } });

export { MsUtilsModule, UtilsService };
